import React from 'react';
import './ServiceHighlights.css';

const ServiceHighlights = props => {
    let items = props.data;
    const navToTrail = props => {
        window.open("https://forms.gle/2itxQL3W6DPE8Sxp8", "_blank");
    };
    return (
        <div className="adg-container">
            <div className="adg-header">
                Featured Services
            </div>
            <div className="adg-container-data" style={{"paddingLeft":"30px", "alignItems":"flex-start"}}>
                {/*<div className="adg-data">*/}
                {/*    <div className="adg-datapoint">Designing and implementing financial systems and planning</div>*/}
                {/*    <div className="adg-datapoint">Budgets and forecasts </div>*/}
                {/*    <div className="adg-datapoint">Digital transformation</div>*/}
                {/*    <div className="adg-datapoint">Cost accounting & payables</div>*/}
                {/*    <div className="adg-datapoint">Revenue Accounting & Receivables </div>*/}
                {/*    <div className="adg-datapoint">Payroll</div>*/}
                {/*    <div className="adg-datapoint">Month end close</div>*/}
                {/*</div>*/}

                {/*<div className="adg-data">*/}
                {/*    <div className="adg-datapoint">Reconciliations</div>*/}
                {/*    <div className="adg-datapoint">Fixed assets accounting</div>*/}
                {/*    <div className="adg-datapoint">MIS</div>*/}
                {/*    <div className="adg-datapoint">Management reporting</div>*/}
                {/*    <div className="adg-datapoint">Financial reporting</div>*/}
                {/*    <div className="adg-datapoint">Consolidation</div>*/}
                {/*</div>*/}

                <div className="services-highlights-container" >
                    {items.map((item, index)=>{
                        return (

                            <div className="service-highlight" onClick={navToTrail}>
                                {item}
                            </div>
                        );
                    })}
                </div>

            </div>
        </div>
    );
};

export default ServiceHighlights;


// WEBPACK FOOTER //
// ./src/Components/ServicesPage/SeviceHighlights/ServiceHighlights.js